// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";

// Import your pages/components
import IndexPage from "./pages/index";
import AboutPage from "./pages/about";
// If you have a Portfolio or Contact component, import them. If not, simple placeholders are provided below:
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import ServicesPage from "./pages/ServicesPage";
import RequestQuote from './pages/QuotePage'
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contact" element={<ContactPage />} /> 

        {/* Example: fallback route */}
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/quote" element={<RequestQuote />} />
        <Route path="*" element={<IndexPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
